import type { MemberPreferences, UpdateMemberPreferencesInput } from '@catalyst-psa/shared';

import { api } from '../api/client.js';

/** Loads the member's saved appearance preferences; returns null on any failure. */
export async function fetchPreferences(): Promise<MemberPreferences | null> {
  try {
    return await api.get<MemberPreferences>('/preferences');
  } catch {
    return null;
  }
}

/** Persists the member's appearance preferences (best-effort; localStorage holds the latest). */
export async function savePreferences(input: UpdateMemberPreferencesInput): Promise<void> {
  try {
    await api.put('/preferences', input);
  } catch {
    /* best-effort persistence */
  }
}
